import React, { useState } from "react";
import { forget_password } from "../../api/urls";
import axios from "axios";
import {
  Box,
  Typography,
  TextField,
  Button,
  Alert,
} from "@mui/material";

const ForgotPassword = () => {
  const [oldPassword, setOldPassword] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);

    if (!oldPassword) {
      setError("Please enter your old password.");
      return;
    }

    if (password !== confirmPassword) {
      setError("Passwords do not match. Please try again.");
      return;
    }

    if (password.length < 8) {
      setError("Password must be at least 8 characters long.");
      return;
    }

    const data = {
      old_password: oldPassword,
      new_password: password,
      confirm_password: confirmPassword,
    };

    const config = {
      url: forget_password,
      method: "PATCH",
      headers: {
        Authorization: "", // Add token if needed
        "Content-Type": "application/json",
      },
      data: data,
    };

    try {
      const response = await axios.request(config);
      if (response.status === 200 && response.data.success) {
        setSuccess("Your password has been reset successfully.");
      } else {
        setError(response.data.message || "Failed to reset password.");
      }
    } catch (err) {
      console.error("Error:", err.response || err);
      setError(
        err.response?.data?.message || "An error occurred. Please try again."
      );
    }
  };

  return (
    <Box
      sx={{
        maxWidth: "622px",
        height: "500px",
        mx: "auto",
        mt: "50px",
        p: 4,
        borderRadius: 2,
        backgroundColor: "#FAF9F8",
        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
        border: "1px solid rgba(0, 0, 0, 0.2)",
        fontFamily: "inherit",
      }}
    >
      <Typography
        variant="h5"
        sx={{
          textAlign: "center",
          mb: 3,
          color: "#333",
          fontWeight: 600,
        }}
      >
        Create New Password
      </Typography>

      <form onSubmit={handleSubmit}>
        <Box mb={2}>
          <Typography
            sx={{
              fontWeight: 600,
              mb: 1,
              color: "#555",
            }}
          >
            Old Password *
          </Typography>
          <TextField
            type="password"
            value={oldPassword}
            onChange={(e) => setOldPassword(e.target.value)}
            placeholder="*******"
            required
            fullWidth
            size="small"
          />
        </Box>

        <Box mb={2}>
          <Typography
            sx={{
              fontWeight: 600,
              mb: 1,
              color: "#555",
            }}
          >
            New Password *
          </Typography>
          <TextField
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="*******"
            required
            fullWidth
            size="small"
          />
        </Box>

        <Box mb={2}>
          <Typography
            sx={{
              fontWeight: 600,
              mb: 1,
              color: "#555",
            }}
          >
            Confirm Password *
          </Typography>
          <TextField
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            placeholder="*******"
            required
            fullWidth
            size="small"
          />
        </Box>

        {error && (
          <Alert severity="error" sx={{ mb: 2, fontSize: "14px" }}>
            {error}
          </Alert>
        )}
        {success && (
          <Alert severity="success" sx={{ mb: 2, fontSize: "14px" }}>
            {success}
          </Alert>
        )}

        <Button
          type="submit"
          variant="contained"
          fullWidth
          sx={{
            backgroundColor: "#000",
            color: "#fff",
            padding: "12px",
            fontSize: "16px",
            borderRadius: "4px",
            textTransform: "none",
            "&:hover": {
              backgroundColor: "#333",
            },
          }}
        >
          Reset Password
        </Button>
      </form>
    </Box>
  );
};

export default ForgotPassword;
